
import { FormRequestTypes } from '@fitogest/reactive-form-builder/form-request';
import {
    Form,
    FormField,
    FormSection,
    FormType,
    InputType,
} from '@fitogest/reactive-form-builder/interfaces';
import { CrmModel } from 'src/app/models/crm/crm.model';

export class CRMConsultasFormDefinition {    
  public formType!: FormType;

  public model: CrmModel = {} as CrmModel;
    
  public formFieldsSection!: FormSection<object>;

  public formFieldsTitular!: FormSection<object>;

  public formFieldsResponsable!: FormSection<object>;
    
  public formFields!: Form<CrmModel>;

  public fieldNames: FormField<any>[] = [];

  public fieldLabels: string[] = [];

  constructor(
    type: FormRequestTypes, 
    _model: Record<string,string>,
    table: (string[] | string[][])[] | null
  ) {
    this.formType = +type;
    
    this.formFields = {
      name: 'crm-consultas',
      header: '',
      type: this.formType,
      sections: this.getFormSections(),
      table: { title: '', showIndex: false, data: table?.[0], style: table?.[1]},
      uploadButton: {
        isEnabled: false,
        label: ''
      },
      signed: false
    };
  }



  public getFormFields(): FormField<any>[] {
    const formFields: FormField<any>[] = [
      {
            name: 'cliente_nombre',
            vinculatedFields: undefined,
            label: 'Cliente',
            input: { type: InputType.TEXT, isEditable: true },
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 1
        },
        {
            name: 'fecha',
            vinculatedFields: undefined,
            label: 'Fecha Acción Comercial',
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 2
        },
        {
            name: 'tarea_comercial',
            vinculatedFields: undefined,
            label: 'Tarea comercial',
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 3
        },
        {
            name: 'interlocutor',
            vinculatedFields: undefined,
            label: 'Interlocutor',
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 3
        },
        {
            name: 'gerente',
            vinculatedFields: undefined,
            label: 'Gerente',
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 4
        },
        {
            name: 'responsable_calidad',
            vinculatedFields: undefined,
            label: 'Responsable de Calidad',
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 5
        },
        {
            name: 'estado_presupuesto',
            vinculatedFields: undefined,
            label: 'Estado presupuesto',
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 6
        },
        {
            name: 'realizado',
            vinculatedFields: undefined,
            label: 'Realizado',
            input: {type: InputType.SWITCH, isEditable: true},
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 7
        },
        {
            name: 'fecha_proxima_accion_comercial',
            vinculatedFields: undefined,
            label: 'Fecha Próxima Acción Comercial',
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 8
        },
        {
            name: 'observaciones',
            vinculatedFields: undefined,
            label: 'Observaciones',
            input: {type: InputType.TEXTAREA, isEditable: true},
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 9
        },
        {
            name: 'observaciones',
            vinculatedFields: undefined,
            label: 'Observaciones',
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 10
        },
        {
            name: 'venta_cruzada',
            vinculatedFields: undefined,
            label: 'Venta Cruzada',
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
              isRememberedOnDuplicate: true,
              isRequired: false,
              isRetained: false,
              hasUndoEnabled: false,
              isVisible: true,
            },
            order: 11
        }
    ];

    this.fieldNames = this.fieldNames.concat(formFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(formFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return formFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  private getFormSections(): FormSection<any>[] {
    const sections: FormSection<any>[] = [
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getFormFields(),
        order: 1
      },
    ];

    return sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }
}